var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region imports

//models
import model from '../base.model';
import { pinModel } from './pin.model';
import { errorModel } from '../service/error.model';

//storage
import { clearLogout as settingsStorageClear } from '../../device/settings.storage';
import { clear as alertStorageClear } from '../../device/alerts.storage';
import { clear as errorStorageClear } from '../../device/errors.storage';
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';
import { load as storageLoad, save as storageSave, fail as storageFail } from '../../device/storage';

//helpers
import { isEmpty } from '../../utils/helpers';
import { getAuthToken } from '../../utils/base64';

//constants
import urls from '../../constants/urls.constant';
import { routes } from '../../constants/routes.constant';
import { config } from '../../config/apiConfig';

//endregion

class loginModel extends model {

    static create() {
        return _extends({}, super.create(), {
            isAuth: false
        });
    }

    //region init

    //endregion

    //region action api

    static apiGet(requestMethod, params = {}) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapToServer(params);
            const { urlParams, authParams } = serverModel;
            const authToken = getAuthToken(authParams.email, authParams.password);
            const url = urls.auth.login(urlParams);
            const serverUrl = yield settingsGetServerUrl();

            return requestMethod(serverUrl, url, serverModel.payload, authToken);
        })();
    }

    static processServerResponse(dispatch, params, model, serverResponse, history) {
        // pre processing
        const modelClient = model.mapToClient(serverResponse);

        // success
        if (modelClient.registered) {
            // clear all errors if logged in
            errorStorageClear();
            dispatch(errorModel.actionClear(errorModel));

            // auth token from params
            const serverModel = this.mapToServer(params);
            const { authParams } = serverModel;
            const authToken = getAuthToken(authParams.email, authParams.password);
            modelClient.authToken = authToken;

            model.storageSaveAuthToken(model, authToken, authParams.email);
            dispatch(model.dispatchModel({ modelClient, model }));
        }
        // fail
        else {
                model.storageSaveAuthToken(model, {});
                throw {
                    message: 'Not registered user: ' + JSON.stringify(params)
                };
            }
    }

    //endregion

    //region actions

    /*
     * Load from localStorage or storage auth info
     * */
    static actionStorageInit(model) {
        return dispatch => {
            dispatch(model.dispatchRequest({ model }));
            const cbSuccess = data => {
                return dispatch({
                    type: model.TYPE__ON_STORAGE_INIT,
                    payload: {
                        model,
                        modelClient: data
                    }
                });
            };
            const cbFail = () => {
                model.storageSaveAuthToken(model, {});
                cbSuccess({ authToken: {} });
            };

            storageLoad(model.MODEL_NAME, cbSuccess, cbFail);
        };
    }

    /*
     * Do logout
     * */
    static actionClear(model) {
        return dispatch => {
            // clear storage
            settingsStorageClear();
            errorStorageClear();
            alertStorageClear();

            model.storageSaveAuthToken(model, {}).then(() => {
                dispatch(model.dispatchClear({ model }));
            });
        };
    }

    //endregion

    //region mapper

    static mapToClient(serverModel) {
        if (isEmpty(serverModel)) {
            return serverModel;
        }

        const {
            groups,
            last_modified,
            permissions,
            principal,
            registered,
            username
        } = serverModel;

        return {
            groups,
            last_modified,
            permissions,
            principal,
            registered,
            username
        };
    }

    static mapToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {};
        }

        const { email, password } = clientModel;
        return {
            urlParams: {},
            authParams: {
                email,
                password
            }
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }

        const reducers = {
            [model.TYPE__ON_STORAGE_INIT]: model.reduceGet.bind(model)
        };
        return reducers[type];
    }

    static reduceRequest(state, action) {
        return _extends({}, super.reduceRequest(state, action), {
            [pinModel.MODEL_NAME]: pinModel.create()
        });
    }

    static reduceGet(stateModel, action, state) {
        const { model, modelClient } = action.payload;
        const { authToken } = modelClient;
        return {
            [model.MODEL_NAME]: _extends({}, modelClient, {
                isLoading: false,
                isAuth: !isEmpty(authToken)
            })
        };
    }

    //endregion

    //region storage

    static storageSaveAuthToken(model, authToken, email, cb = void 0) {
        return storageSave(model.MODEL_NAME, { authToken, email }).then(cb);
    }

    /*
     * Call callback cb if user not authorised in callback will be redirect to login page
     * */
    static storageIsAuth(model, cb = void 0) {
        const cbSuccess = data => {
            if (!data) {
                cb(data);
                return;
            }

            const { authToken } = data;
            if (isEmpty(authToken)) {
                cb(data);
            }
        };

        return storageLoad(model.MODEL_NAME, cbSuccess);
    }

    /*
     * Call callback cb if user authorised in callback will be redirect to home page
     * */
    static storageIsNonAuth(model, cb = void 0) {
        const cbSuccess = data => {
            if (!data) {
                return;
            }

            const { authToken } = data;
            if (!isEmpty(authToken)) {
                cb(data);
            }
        };

        return storageLoad(model.MODEL_NAME, cbSuccess);
    }

    //endregion
}

loginModel.MODEL_NAME = 'loginModel';
loginModel.TYPE_REQUEST = 'REQUEST_LOGIN';
loginModel.TYPE_FROM_SERVER = 'GET_LOGIN';
loginModel.TYPE_CLEAR = 'CLEAR_LOGIN';
loginModel.TYPE__ON_STORAGE_INIT = 'TYPE_LOGIN__STORAGE_INIT';

loginModel.storageGetAuthToken = (() => {
    var _ref = _asyncToGenerator(function* (model) {
        let data = yield storageLoad(model.MODEL_NAME);
        const { authToken, email } = data;
        return { authToken, email };
    });

    return function (_x) {
        return _ref.apply(this, arguments);
    };
})();

export { loginModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/auth/login.model.js